import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#9E77ED",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M1 5h8M2.171 2.172l5.657 5.656M5 1v8m2.828-6.828L2.172 7.828"
    }, null, -1)
  ])))
}
export default { render: render }